import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";
import { CAMCFundFOFHandler } from "_fil_local_addon/camc-fund-detail-app/camc-fund-detail-app";

class TabItemsDisplayControl {
    constructor(control_type_list) {
        this.control_type_list = control_type_list;
    }

    render() {
        const controlMap = {
            esg: this.esgTabDisplayControl,
            // fof: this.fofTabDisplayControl,
        };

        for (let controlType of this.control_type_list) {
            if (controlMap[controlType]) {
                controlMap[controlType]();
            }
        }
    }

    async fofTabDisplayControl() {
        const isfof = await CAMCFundFOFHandler.getIsFOF();
        const $fofTab = $(".fil-tabs").find("li#tab-fof");
        if (isfof) {
            $fofTab.removeClass("hide");
        } else {
            $fofTab.remove();
        }
    }

    async esgTabDisplayControl() {
        const data = await FundReportService.getFundReport(window.fundCode, "esg");
        const $esgTab = $(`.tabs #tab-esg`);
        if ($esgTab) {
            if (data.length) {
                $esgTab.removeClass("hide");
            } else {
                $esgTab.addClass("hide");
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (window.fundCode && window.control_type_list) {
        const tabItemsDisplayControl = new TabItemsDisplayControl(window.control_type_list);
        tabItemsDisplayControl.render();
    }
});

export default { TabItemsDisplayControl };
